var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _vm.list.length > 0
        ? _c(
            "div",
            { staticClass: "tops flex", attrs: { id: "imageList" } },
            [
              _c(
                "swiper",
                {
                  ref: "mySwipers",
                  staticClass: "imgcasesT",
                  attrs: { options: _vm.swiperOption },
                },
                _vm._l(_vm.list, function (it, index) {
                  return _c(
                    "swiper-slide",
                    { key: index, staticClass: "swiper-slides" },
                    [
                      _c("div", { staticClass: "cubeBox" }, [
                        _c("div", { staticClass: "img-item" }, [
                          _c("div", { staticClass: "imgBox" }, [
                            _c("img", {
                              attrs: { src: it.imgPath },
                              on: {
                                click: function ($event) {
                                  return _vm.previewClick(index)
                                },
                              },
                            }),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", {
        staticClass: "swiper-button-prev",
        on: {
          click: function ($event) {
            return _vm.prevs()
          },
        },
      }),
      _c("div", {
        staticClass: "swiper-button-next",
        on: {
          click: function ($event) {
            return _vm.nexts()
          },
        },
      }),
      _c("image-preview2", {
        attrs: {
          show: _vm.imgpre,
          list: _vm.imglist,
          initialIndex: _vm.initialIndex,
        },
        on: {
          "update:show": function ($event) {
            _vm.imgpre = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }